<div class="card equal">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="card-title">Fundamentals</h4>
        <div 
        placement="left bottom"
        ngbTooltip="The FUNDAMENTAL section evaluates the value of a crypto coin based on a few metrics that affect the project's potential, user participation and engagement, and utility values, all of which will determine the price and volatility of the coin.">
            <i data-feather="help-circle" class="font-medium-3 text-muted cursor-pointer"></i>
        </div>
    </div>
    <div class="crypto-card-height card-body">
        <div class="row avg-sessions pt-50">
            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <div class="d-flex">
                  <img src="assets/images/icons/ConcentrationScore.png" alt="ConcentrationScore" class="score-icon">
                  <p class="mb-50">Concentration Score: {{ tickerScore?.concentration_score ? tickerScore?.concentration_score : 0 }}</p>
                </div>

                <div 
                placement="left bottom"
                ngbTooltip="Concentration is measured by the percentage of ownership by whales, investors, and retailers. A WHALE defines those addresses owning more than 1% of the coin; investors are those in the range of 0.1% - 1%; the rest are categorized as retail. High-quality crypto assets should have diversified ownership distribution that lower the ownership of the whale and investor ownership (or, in other words, the higher the retail ownership), the higher the score. The score is calculated based on the coin’s historical trends of ownership and benchmark comparison against other coins. A score of 50 represents the neutral level of concentration; the lower the concentration, the higher the score.">
                    <i data-feather="help-circle" class="font-medium-3 text-muted cursor-pointer"></i>
                </div>
              </div>
        
              <ngb-progressbar
                [type]="tickerScore?.concentration_score > 70 ? 'success' : 'danger'"
                [type]="tickerScore?.concentration_score >= 40 && tickerScore?.concentration_score <= 70 ? 'warning' : 'danger'"
                [type]="tickerScore?.concentration_score < 39 ? 'danger' : 'danger'"
                [height]="'6px'"
                [value]="tickerScore?.concentration_score ? tickerScore?.concentration_score : 0"
              ></ngb-progressbar>
            </div>
            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <div class="d-flex">
                  <img src="assets/images/icons/HolderFlowScore.png" alt="HolderFlowScore" class="score-icon">
                  <p class="mb-50">Holder Flow Score: {{ tickerScore?.holder_flow_score ? tickerScore?.holder_flow_score : 0 }}</p>
                </div>

                <div 
                placement="left bottom"
                ngbTooltip="The holder flow score measures the activities of inflow and outflow trends of large addresses, namely whale and investors, which indicates the conviction of large holders on the coin. The inflow of transactions to these large holders normally are bullish signs to the coin, while outflow is the opposite. Inflow and outflow are happening daily, so we also measure the NetFlow to understand actual activities better. The score is calculated based on the trend Netflow. A score of 50 means the Netflow is neutral; the higher the inflow, the higher the score.">
                    <i data-feather="help-circle" class="font-medium-3 text-muted cursor-pointer"></i>
                </div>
              </div>
        
              <ngb-progressbar
                [type]="tickerScore?.holder_flow_score > 70 ? 'success' : 'danger'"
                [type]="tickerScore?.holder_flow_score >= 40 && tickerScore?.holder_flow_score <= 70 ? 'warning' : 'danger'"
                [type]="tickerScore?.holder_flow_score < 39 ? 'danger' : 'danger'"
                [height]="'6px'"
                [value]="tickerScore?.holder_flow_score ? tickerScore?.holder_flow_score : 0"
              ></ngb-progressbar>
            </div>
            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <div class="d-flex">
                  <img src="assets/images/icons/MinerScore.png" alt="MinerScore" class="score-icon">
                  <p class="mb-50">Miner Score: {{ tickerScore?.miner_score ? tickerScore?.miner_score : 0 }}</p>
                </div>

                <div 
                placement="left bottom"
                ngbTooltip="Miner score measures the balances of addresses belonging to mining pools. Miner participation and activeness are important indicators of the value of the coin. The increasing mining pool suggests a bullish trend for the coin. Miners' score is calculated based on a coin’s miner reserve trend and market benchmark. A score of 50 suggests neutral or stable minor activities. The accelerated miner reserve increase yields a higher score.">
                    <i data-feather="help-circle" class="font-medium-3 text-muted cursor-pointer"></i>
                </div>
              </div>
        
              <ngb-progressbar
                [type]="tickerScore?.miner_score > 70 ? 'success' : 'danger'"
                [type]="tickerScore?.miner_score >= 40 && tickerScore?.miner_score <= 70 ? 'warning' : 'danger'"
                [type]="tickerScore?.miner_score < 39 ? 'danger' : 'danger'"
                [height]="'6px'"
                [value]="tickerScore?.miner_score ? tickerScore?.miner_score : 0"
              ></ngb-progressbar>
            </div>
            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <div class="d-flex">
                  <img src="assets/images/icons/StakingScore.png" alt="StakingScore" class="score-icon">
                  <p class="mb-50">Staking Score: {{ tickerScore?.staking_score ? tickerScore?.staking_score : 0 }}</p>
                </div>

                <div 
                placement="left bottom"
                ngbTooltip="Staking is one of the most popular ways for crypto coin owners to generate interest in their assets. The growing size of staking indicates the conviction of the coin holders on the medium and long-term view, as staking is not risk-free and has a barrier to entry. Highly staked coins usually have better performance is lower volatility. The staking score is a measure based on the trend of the size of the staking pool by comparing a coin’s history and market benchmark. A score of 50 suggests stable staking growth. The faster the growth, the higher the score.">
                    <i data-feather="help-circle" class="font-medium-3 text-muted cursor-pointer"></i>
                </div>
              </div>
        
              <ngb-progressbar
                [type]="tickerScore?.staking_score > 70 ? 'success' : 'danger'"
                [type]="tickerScore?.staking_score >= 40 && tickerScore?.staking_score <= 70 ? 'warning' : 'danger'"
                [type]="tickerScore?.staking_score < 39 ? 'danger' : 'danger'"
                [height]="'6px'"
                [value]="tickerScore?.staking_score ? tickerScore?.staking_score : 0"
              ></ngb-progressbar>
            </div>
            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <div class="d-flex">
                  <img src="assets/images/icons/CommunityScore.png" alt="CommunityScore" class="score-icon">
                  <p class="mb-50">Community Score: {{ tickerScore?.community_score ? tickerScore?.community_score : 0 }}</p>
                </div>

                <div 
                placement="left bottom"
                ngbTooltip="Community score measures the strength and diligence of the development team. Currently, the score is calculated based on the trend of GitHub development activities by comparing history and benchmarking with other projects. A score of 50 suggests neutral, stable development activities. The higher the score, the more GitHub activities, such as commits and pull requests.">
                    <i data-feather="help-circle" class="font-medium-3 text-muted cursor-pointer"></i>
                </div>
              </div>
              <ngb-progressbar
                  [type]="tickerScore?.community_score > 70 ? 'success' : 'danger'"
                  [type]="tickerScore?.community_score >= 40 && tickerScore?.community_score <= 70 ? 'warning' : 'danger'"
                  [type]="tickerScore?.community_score < 39 ? 'danger' : 'danger'"
                  [height]="'6px'"
                  [value]="tickerScore?.community_score ? tickerScore?.community_score : 0"
              ></ngb-progressbar>
            </div>
          </div>
    </div>
</div>

<ng-template #scoreTemp let-value="value">
    <div class="w-full py-1">
      <div *ngIf="value > 70" class="badge-light-success badge badge-pill px-1"><span>{{value}}</span></div>
      <div *ngIf="value >= 40 && value <= 70" class="badge-light-warning badge badge-pill px-1"><span>{{value}}</span></div>
      <div *ngIf="value < 39" class="badge-light-danger badge badge-pill px-1"><span>{{value}}</span></div>
      <!-- <div *ngIf="value == 0" class="badge badge-pill badge-light-secondary px-1"><span>{{value}}</span></div> -->
    </div>
</ng-template>